exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/home/bitrix/ext_www/russoutdoor.ru/public_html/assets","/static":"/home/bitrix/ext_www/russoutdoor.ru/public_html/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43f11f6a","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./pages/oferta.vue
// module id = 8D66
// module chunks = 35